import {IAddShelf} from "src/store/actions";
import {IAppState} from "src/store/models";

export const addShelfReducer = (state: IAppState, action: IAddShelf) => {
    const shelves = state.shelves;
    const id = action.payload;
    return {
        ...state,
        shelves: {
            ...shelves,
            [id]: {boxesIds: [], id}
        },
        shelvesOrder: [...state.shelvesOrder, id]
    };
};


// WEBPACK FOOTER //
// ./src/store/reducers/adding/addShelfReducer.ts